import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import "react-widgets/styles.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import './fonts/GothamRounded/GothamRoundedLight.ttf';
import './fonts/GothamRounded/GothamRoundedBook.ttf';
import './fonts/GothamRounded/GothamRoundedMedium.ttf';
import './fonts/GothamRounded/GothamRoundedBold.ttf';


createRoot(document.getElementById("root"))
  .render(<App />)